// generated by genversion
const version = '6.6.6';

export { version };
//# sourceMappingURL=version.mjs.map
